// ** Third Party Components
import { useTranslation } from 'react-i18next'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap'

import enFlag from '@src/assets/images/icons/flags/en.svg';
import itFlag from '@src/assets/images/icons/flags/it.svg';

const IntlDropdown = (props) => {
    // ** Hooks
    const { i18n, t } = useTranslation()
    const { linkStyles}  = props

    // ** Vars
    const langObj = {
        it: 'Italian',
        en: 'English'
    }

    // ** Function to switch Language
    const handleLangUpdate = (e, lang) => {
        e.preventDefault()
        i18n.changeLanguage(lang)
    }

    return (
        <UncontrolledDropdown href='/' tag='li' className='dropdown-language nav-item'>
            <DropdownToggle href='/' tag='a' className='nav-link' style={linkStyles} onClick={e => e.preventDefault()}>
                <img alt="" className={"country-flag"} src={i18n.language === 'it' ? itFlag : enFlag }/>
                <span className='mx-1 selected-language'>{t(langObj[i18n.language])}</span>
            </DropdownToggle>
            <DropdownMenu className='mt-0' end>
                <DropdownItem href='/' tag='a' onClick={e => handleLangUpdate(e, 'en')}>
                    <img alt={"en"} className={"country-flag"} src={enFlag}/>
                    <span className={`fi fi-us ms-1`}>{t("English")}</span>
                </DropdownItem>

                <DropdownItem href='/' tag='a' onClick={e => handleLangUpdate(e, 'it')}>
                    <img alt={"it"} className={"country-flag"} src={itFlag}/>
                    <span className='fi fi-it ms-1'>{t("Italian")}</span>
                </DropdownItem>

            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default IntlDropdown
